import { useState, useEffect } from 'react';
import api from '../../../api/client';

export default function RunsPage() {
  const [items,   setItems]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);
  const [busyId,  setBusyId]  = useState(null);

  async function load() {
    setLoading(true);
    try {
      const { data } = await api.get('/bp/runs');
      setItems(data.data?.items || []);
    } catch (e) {
      setError(e.response?.data?.message || e.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { load(); }, []);

  async function handleRefresh(runId) {
    setBusyId(runId);
    setError(null);
    try {
      await api.post(`/bp/runs/${runId}/refresh`);
      await load();
    } catch (e) {
      setError(e.response?.data?.message || e.message);
    } finally {
      setBusyId(null);
    }
  }

  return (
    <div data-testid="bp-runs-page" data-loading={loading ? 'true' : 'false'}>
      <h2>Process Runs</h2>

      {error && <p style={{ color: 'red' }}>{error}</p>}

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table style={{ width: '100%' }}>
          <thead>
            <tr>
              <th>Definition</th>
              <th>Resource Type</th>
              <th>Resource Id</th>
              <th>Instance</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.map((r) => (
              <tr key={r.id} data-testid={`bp-run-row-${r.id}`}>
                <td>{r.definition_id}</td>
                <td>{r.resource_type}</td>
                <td>{r.resource_id}</td>
                <td>{r.workflow_instance_id || '—'}</td>
                <td>{r.status}</td>
                <td>
                  <button
                    data-testid={`bp-run-refresh-${r.id}`}
                    onClick={() => handleRefresh(r.id)}
                    disabled={busyId === r.id}
                  >
                    {busyId === r.id ? 'Refreshing...' : 'Refresh'}
                  </button>
                </td>
              </tr>
            ))}
            {!items.length && <tr><td colSpan={6}>No process runs yet.</td></tr>}
          </tbody>
        </table>
      )}
    </div>
  );
}
